import React, { useState } from "react";
import useSupabaseBrowser from "../hooks/use-supabase-browser";
import { useNotifications } from "../providers/notifications";

export default () => {
  const supabase = useSupabaseBrowser();

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const { notify } = useNotifications();

  const handleLogin = async (event) => {
    event.preventDefault();

    setLoading(true);
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: window.location.origin,
        shouldCreateUser: false,
      },
    });

    if (error) {
      console.log(error);
      notify(
        "The email you entered doesn't match our records." +
          "Please double-check and try again." +
          "If the error persists contact hello@prontovalet.pro",
        "error",
        30000
      );
    } else {
      setShowSuccess(true);
    }
    setLoading(false);
  };

  if (showSuccess)
    return (
      <div className="flex flex-col gap-y-4 text-center h-screen">
        <div className="m-auto flex flex-col gap-y-4 text-center">
          <div className="text-xl">Pronto Valet Admin Dashboard</div>
          <div className="text-3xl">Check your email for the login link</div>
        </div>
      </div>
    );

  return (
    <div className="flex flex-col gap-y-4 text-center h-screen">
      <div className="m-auto flex flex-col gap-y-4 text-center">
        <div className="text-xl">Pronto Valet Admin Dashboard</div>
        <div className="text-l">
          Sign in via magic link with your email below
        </div>
        <form onSubmit={handleLogin}>
          <div>
            <input
              className="input input-bordered w-full"
              type="email"
              placeholder="Your email"
              value={email}
              required={true}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <button
              className={"btn btn-success w-full mt-4"}
              disabled={loading}
            >
              {loading ? <span>Loading</span> : <span>Send magic link</span>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
